/**
 * Copyright 2021, IntraLinks, Inc. All rights reserved.
 */
import React from 'react';
import { useSelector } from 'react-redux';
import {
  IlCard, IlLoading, IlTab, IlTabs
} from 'il-framework-component';
import { useTranslation } from 'react-i18next';
import CommonStyles from '../../../scss/Common.scss';
import EmailPreferencesStyles from './EmailPreferences.scss';
import { RootState } from '../../../app/store';
import { I18nNamespaces } from '../../../app/shared/utils/constants.util';
import DealCentreEmailPreferencesClassComponent from './DealCentreEmailPreferences';

const PREFERENCES_TABS = ['d1c5ffd8-560e-4962-8017-eebfd9fddc25'];

const EmailPreferences: React.FC = () => {
  const { t } = useTranslation(I18nNamespaces.PROFILE);
  const isAppLoading = useSelector((state: RootState) => state.appState.isAppLoading);
  const applications = useSelector((state: RootState) => state.profile.applications);

  return (
    <div className={CommonStyles.container}>
      {isAppLoading && <IlLoading withOverlay />}
      <IlCard title={t('profile.emailPreferences')} className={EmailPreferencesStyles.emailPreferencesCard}>
        <IlTabs
          selected={0}
          type='container'
        >
          {applications.filter((app) => PREFERENCES_TABS.includes(app.id))
            .map((app) => (
              <IlTab
                id={app.id}
                label={app.name}
                selected
                tabIndex={0}
                renderContent={DealCentreEmailPreferencesClassComponent}
              />
            ))}
        </IlTabs>
      </IlCard>
    </div>
  );
};

export default EmailPreferences;
